module.exports = __webpack_public_path__ + "img/soft_8.1ec81cc2.png";